import React from "react";
import { Button, Chip } from "@mui/material";
import DownArrow from "../../../../styles/svg/downArrow.svg";
import { CustomButton } from "../../../../components/Button/Button";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAllGroupUser } from "../../../../redux/TaskGroupingSlice";

const TeamButton = ({ user, setAnchorEl }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  const handleDeleteTeam = () => {
    removeSearchParams(["uid"]);
    dispatch(setAllGroupUser([]));
  };

  const removeSearchParams = (paramsToRemove) => {
    const newSearchParams = new URLSearchParams(searchParams);
    paramsToRemove.forEach((param) => {
      newSearchParams.delete(param);
    });
    setSearchParams(newSearchParams);
  };

  return (
    <CustomButton
      variant="outlined"
      color="primary"
      id="epics-board-dropdown"
      aria-haspopup="true"
      onClick={(event) => setAnchorEl(event.currentTarget)}
      endIcon={<img src={DownArrow} />}
      className=" white-button ml-2 team-button w-auto">
      <Chip
        label={
          <div className="d-flex justify-content-space-between">
            <p className="filter-name">Users</p>
            <p className="filter-count">
              {user.length === 0 ? "" : user.length}
            </p>
          </div>
        }
        className="filter-chip"
        {...(user.length > 0 ? { onDelete: handleDeleteTeam } : {})}
      />
    </CustomButton>
  );
};

export default TeamButton;
